import React from "react";
import { PageShell } from "@/components/Navbar";
import { MyPropertiesPanel } from "@/components/MyPropertiesPanel";

export default function MyProperties() {
  return (
    <PageShell testid="my-properties-page">
      <MyPropertiesPanel />
    </PageShell>
  );
}
